import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  VStack,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { FaSync } from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Homework = () => {
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [message, setMessage] = useState("");
  const userid = sessionStorage.getItem("user_id");

  useEffect(() => {
    // Fetch classes
    axios
      .get(`${BASE_URL}/admin/class/class_master.php`)
      .then((response) => {
        setClasses(response.data.data || []);
      })
      .catch((error) => {
        console.error("Error fetching classes:", error);
      });

    // Fetch subjects
    axios
      .get("${BASE_URL}/admin/subject/list_subject.php")
      .then((response) => {
        setSubjects(response.data.data || []);
      })
      .catch((error) => {
        console.error("Error fetching subjects:", error);
      });
  }, []);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setMessage("Please select a file.");
      return;
    }

    const fileBase64 = await toBase64(file);

    if (
      !userid ||
      !selectedClass ||
      !selectedSubject ||
      !title ||
      !description
    ) {
      setMessage("Please fill out all required fields.");
      return;
    }

    const postData = {
      pass: userid, // Matching the 'pass' parameter in PHP
      class_id: selectedClass,
      subject_id: selectedSubject,
      title: title, // Title for homework
      description: description, // Description for homework
      material_file: fileBase64, // Base64-encoded file
    };

    console.log(postData);

    try {
      const response = await axios.post(
        `${BASE_URL}/staff/homework/create_homework.php`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        setMessage("Homework uploaded successfully!");

        // Reset form fields
        setSelectedClass("");
        setSelectedSubject("");
        setFile(null);
        setTitle("");
        setDescription("");

        // Optionally clear the success message after 3 seconds
        setTimeout(() => {
          setMessage("");
        }, 3000);
      } else {
        setMessage(
          `Failed to upload homework: ${
            response.data.message || "Unknown error"
          }`
        );
      }
    } catch (error) {
      console.error("Error during file upload:", error);
      setMessage("An error occurred while uploading the homework.");
    }
  };

  return (
    <Box>
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px", margin: 0 }}>Homework</h1>
            {/* <div className="action-buttons">
              <Button
                className="refresh-button"
                boxShadow="md" // Applies a medium shadow
                backgroundColor="white"
                fontSize="11px"
                onClick={() => {
                  window.location.reload();
                }}
              >
                <FaSync color="#515B73" />
              </Button>
            </div> */}
          </div>

          <div className="breadcrumb">
            <span>Staff</span> / <span>Material</span> / <span>Homework</span>
          </div>
        </div>
        <Box
          p={6}
          mx="auto"
          mt={6}
          bg="white"
          borderRadius="md"
          boxShadow="md"
          maxWidth={{ base: "90%", sm: "80%", md: "70%", lg: "60%" }}
        >
          <form onSubmit={handleSubmit}>
            <VStack spacing={4}>
              {message && (
                <Alert
                  status={
                    message.includes("successfully") ? "success" : "error"
                  }
                >
                  <AlertIcon />
                  {message}
                </Alert>
              )}

              <FormControl id="class" isRequired>
                <FormLabel>Class</FormLabel>
                <Select
                  placeholder="Select Class"
                  value={selectedClass}
                  onChange={(e) => setSelectedClass(e.target.value)}
                >
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.class}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl id="subject" isRequired>
                <FormLabel>Subject</FormLabel>
                <Select
                  placeholder="Select Subject"
                  value={selectedSubject}
                  onChange={(e) => setSelectedSubject(e.target.value)}
                >
                  {subjects.map((subject) => (
                    <option key={subject.id} value={subject.id}>
                      {subject.subject}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl id="title" isRequired>
                <FormLabel>Title</FormLabel>
                <Input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </FormControl>

              <FormControl id="description" isRequired>
                <FormLabel>Description</FormLabel>
                <Input
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </FormControl>

              <FormControl id="file" isRequired>
                <FormLabel>Homework File</FormLabel>
                <Input
                  type="file"
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </FormControl>

              <Button colorScheme="teal" type="submit">
                Upload
              </Button>
            </VStack>
          </form>
        </Box>
      </div>
    </Box>
  );
};

export default Homework;
